import { render, staticRenderFns } from "./CouvertureIngredient.vue?vue&type=template&id=46fd3b67"
import script from "./CouvertureIngredient.vue?vue&type=script&lang=js"
export * from "./CouvertureIngredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports